/**
 * Run the same request for each item. One failure does not cancel the rest.
 */
export default async function runBulkRequests(items, request) {
  const results = await Promise.allSettled(
    items.map(async (item) => {
      await request(item);
      return item;
    }),
  );

  const succeededIds = [];
  const failedIds = [];
  results.forEach((result, index) => {
    if (result.status === "fulfilled") succeededIds.push(result.value);
    else failedIds.push(items[index]);
  });

  return {
    succeededIds,
    failedIds,
    succeeded: succeededIds.length,
    failed: failedIds.length,
  };
}
